/*!
 * Loader
 * DOM이 일정기간 동안 실행되지 않을 경우 본문에 스피너 클래스 추가
 */

(function () {
  let isContentLoaded = false;
  const timeoutId = setTimeout(() => {
    if (!isContentLoaded) {
      document.body.classList.add('spinner');
    }
  }, 500);

  window.addEventListener('DOMContentLoaded', (event) => {
    isContentLoaded = true;
  });
})();
